var cilMobile = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M380,16H132a32.036,32.036,0,0,0-32,32V464a32.036,32.036,0,0,0,32,32H380a32.036,32.036,0,0,0,32-32V48A32.036,32.036,0,0,0,380,16Zm0,32V80H132V48Zm0,64,.011,224H132V112Zm0,352H132V368H380.016l0,96Z' class='ci-primary'/><rect width='32' height='32' x='240' y='400' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilMobile };

